import { useContext } from 'react'
import { createPortal } from 'react-dom'

import { Button } from '@/components'

import { DialogContext } from './Dialog.context'
import { ButtonGroup, Content, Modal, Overlay, Title, IconContainer } from './Dialog.styles'

const $domElement = document.getElementById('dialog') || document.body

export function Component(): React.ReactPortal | null {
  const context = useContext(DialogContext)

  if (!context) return null

  const { isOpen, data, close } = context

  function handleClose() {
    close()
  }

  function handleOverlayClick(e: React.MouseEvent) {
    if (e.target === e.currentTarget) {
      handleClose()
    }
  }

  if (!isOpen || !data) return null

  return createPortal(
    <Overlay onClick={handleOverlayClick}>
      <Modal onClick={(e) => e.stopPropagation()} $size={data.size}>
        {data.icon && <IconContainer>{data.icon}</IconContainer>}
        <Title>
          {typeof data.title === 'string' ?
            <h2>{data.title}</h2>
          : data.title}
        </Title>
        <Content $size={data.size}>{data.content}</Content>
        <ButtonGroup $justified={data.justifiedButtons}>
          {data.customActions || (
            <Button.Root $variant="primary" onClick={handleClose}>
              <Button.Text value={data.closeText} />
            </Button.Root>
          )}
        </ButtonGroup>
      </Modal>
    </Overlay>,
    $domElement,
  )
}
